"use client";

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useState, useEffect } from "react";
import Steper from "@/components/ui/Steper";
import { toast } from "sonner";
import { ChevronLeftIcon, ChevronRightIcon, XIcon, PlusIcon, LoaderCircleIcon, PanelsTopLeftIcon, BoxIcon } from "lucide-react";
import { DynamicSelect, Icons, TagInputs } from "@/components";
import { Textarea } from "@/components/ui/textarea";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Switch } from "@/components/ui/switch";
import { CheckCircle, DollarSign, Percent, TrendingUp } from "lucide-react";

import { Calendar as CalendarIcon } from "lucide-react"
import { Calendar } from "react-multi-date-picker";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover"
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { cn, formatNerkh } from "@/lib/utils";

const steps = [
    { step: 1, title: "مرحله اول", description: "اطلاعات عمومی" },
    { step: 2, title: "مرحله دوم", description: "آپلود تصاویر" },
    { step: 3, title: "مرحله سوم", description: "جزئیات محصول" },
];

const EditProductModal = ({ isOpen, setIsOpen, product, setProduct }: any) => {
    const [date, setDate]: any = useState([]);
    const [modalProduct, setModalProduct] = useState(product);
    const [nerkhLoading, setNerkhLoading]: any = useState(false)
    const [nerkhList, setNerkhList] = useState([]);
    const [selectedNerkh, setSelectedNerkh]: any = useState(modalProduct.nerkhId ? modalProduct.nerkhId : null);
    const [selectedNerkhData, setSelectedNerkhData]: any = useState(null);

    const [inventoryLoading, setInventoryLoading]: any = useState(false);
    const [invetories, setInventories]: any = useState([]);
    const [selectedInventory, setSelectedInventory]: any = useState(modalProduct.inventoryId ? modalProduct.inventoryId : null)

    const [currentStep, setCurrentStep] = useState(1);
    const [isLoading, setIsLoading] = useState(false);

    const [isCalcLoading, setIsCalcLoading] = useState(false);

    const [isOffPriceChecked, setIsOffPriceChecked] = useState(false);
    const [isAutoPriceChecked, setIsAutoPriceChecked] = useState(false);

    const [hasOption, setHasOption]: any = useState(false);
    const [priceDetails, setPriceDetails] = useState<string | null>(null);
    const [isRequiresUserInputChecked, setIsRequiresUserInputChecked] = useState(
        modalProduct.requiresUserInput
    );


    const [categories, setCategories]: any = useState([]);
    const [selectedParentCategory, setSelectedParentCategory]: any = useState(modalProduct.categoryParent || "");
    const [selectedChildCategory, setSelectedChildCategory]: any = useState(modalProduct.categoryChild || "");
    const [isNewCategory, setIsNewCategory]: any = useState(false);
    const [newCategoryName, setNewCategoryName]: any = useState("");

    const fetchCategories = async () => {
        try {
            const response = await fetch("/api/category/get");
            if (!response.ok) throw new Error("خطا در دریافت دسته‌بندی‌ها");

            const data = await response.json();
            setCategories(data);
        } catch (error) {
            console.error("خطا در دریافت دسته‌ها:", error);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);





    useEffect(() => {
        if (isOpen) {
            setModalProduct(product);
        }
    }, [isOpen]);

    const handleDateChange = (range: any) => {
        if (range) {
            setDate(range);
            setModalProduct((prev: any) => ({
                ...prev,
                discount: {
                    ...prev.discount,
                    startAt: range[0],
                    expiresAt: range[1],
                },
            }));
        }
    };


    const handleNext = () => {
        if (currentStep < steps.length) setCurrentStep(currentStep + 1);
    };

    const handlePrev = () => {
        if (currentStep > 1) setCurrentStep(currentStep - 1);
    };

    const handleProductFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            if (file.type !== "application/zip" && !file.name.endsWith(".zip")) {
                toast.error("لطفاً فقط فایل‌های ZIP آپلود کنید!");
                return;
            }
            setModalProduct((prev: any) => ({ ...prev, file: e.target.files?.[0] }));
        }
    };

    const handleRemoveFile = () => {
        setModalProduct((prev: any) => ({ ...prev, file: null }));
    };


    const handleProductImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const files = Array.from(e.target.files);
            setModalProduct((prev: any) => ({ ...prev, images: [...(prev.images || []), ...files] }));
        }
    };

    const handleCoverImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            setModalProduct((prev: any) => ({ ...prev, coverImage: e.target.files?.[0] }));
        }
    };

    const handleRemoveProductImage = (index: number) => {
        setModalProduct((prev: any) => ({
            ...prev,
            images: prev.images.filter((_: any, i: number) => i !== index),
        }));
    };

    const handleRemoveCoverImage = () => {
        setModalProduct((prev: any) => ({ ...prev, coverImage: null }));
    };



    // has option
    // useEffect(() => {
    //     if (hasOption) {
    //         let basePrice = 0;

    //         modalProduct.options.forEach((option: any) => {
    //             const baseValues = option.values.filter((v: any) => v.type === "base");
    //             if (baseValues.length > 0) {
    //                 let minPrice = Math.min(...baseValues.map((v: any) => v.priceModifier));

    //                 // بررسی مقدار applyRateToValue
    //                 const selectedBaseValue = baseValues.find((v: any) => v.priceModifier === minPrice);
    //                 if (selectedBaseValue?.applyRateToValue) {
    //                     minPrice *= modalProduct.usdtBaseRate; // تبدیل به تومان با نرخ USDT
    //                 }

    //                 basePrice += minPrice;
    //             }
    //         });

    //         // اعمال تنظیمات نرخ
    //         let finalPrice = basePrice * modalProduct.multiplier;
    //         finalPrice += (finalPrice * modalProduct.profitMargin) / 100; // اعمال سود
    //         finalPrice += (finalPrice * modalProduct.feePercentage) / 100; // اعمال کارمزد
    //         if (finalPrice < modalProduct.minRate) finalPrice = modalProduct.minRate; // بررسی حداقل قیمت

    //         // گرد کردن قیمت
    //         const roundedPrice =
    //             modalProduct.roundingType === "up"
    //                 ? Math.ceil(finalPrice / modalProduct.roundingValue) * modalProduct.roundingValue
    //                 : modalProduct.roundingType === "down"
    //                     ? Math.floor(finalPrice / modalProduct.roundingValue) * modalProduct.roundingValue
    //                     : Math.round(finalPrice / modalProduct.roundingValue) * modalProduct.roundingValue;

    //         setModalProduct((prev: any) => ({
    //             ...prev,
    //             price: roundedPrice,
    //         }));
    //     }
    // }, [modalProduct.options, hasOption]);


    useEffect(() => {
        if (modalProduct.autoPriceEnabled) {
            setNerkhLoading(true)
            const fetchUSDTPrice = async () => {
                try {
                    const response = await fetch("/api/nerkh/get")
                    const data = await response.json();
                    if (!data.success) throw new Error("خطا در دریافت نرخ");


                    setNerkhList(data.data);
                    setNerkhLoading(false)
                } catch (error) {
                    setNerkhLoading(false)
                    console.error("خطا در دریافت نرخ:", error);
                }
            };

            fetchUSDTPrice();


        }


        if (modalProduct.deliveryMethod === 'automatic') {
            setInventoryLoading(true)
            const fetchInventories = async () => {
                try {
                    const response = await fetch("/api/inventory/get")
                    const data = await response.json();
                    if (!data.success) return toast.error('خطا در دریافت خزانه')


                    setInventories(data?.inventories);
                    setInventoryLoading(false)
                } catch (error) {
                    setInventoryLoading(false)
                    console.error("خطا در دریافت خزانه:", error);
                }
            };

            fetchInventories();


        }
    }, [modalProduct.autoPriceEnabled, modalProduct.deliveryMethod]);

    const calculateOptionPrice = () => {
        let basePrice = 0;
        let updatedOptions = JSON.parse(JSON.stringify(modalProduct.options)); // جلوگیری از تغییر مستقیم

        updatedOptions.forEach((option: any) => {
            option.values.forEach((value: any) => {
                if (value.applyRateToValue) {
                    // محاسبه قیمت بر اساس نرخ USDT و تنظیمات نرخ
                    value.price = value.priceModifier
                    let convertedPrice = value.priceModifier * modalProduct.usdtBaseRate;

                    // اعمال ضریب
                    convertedPrice *= modalProduct.multiplier;

                    // اعمال سود
                    const profitAmount = (convertedPrice * modalProduct.profitMargin) / 100;
                    convertedPrice += profitAmount;

                    // اعمال کارمزد
                    const feeAmount = (convertedPrice * modalProduct.feePercentage) / 100;
                    convertedPrice += feeAmount;

                    // بررسی حداقل قیمت
                    if (value.hasMinimumPrice) {
                        if (convertedPrice < value.minimumPriceModifier) {
                            convertedPrice = value.minimumPriceModifier
                        }
                    }

                    // گرد کردن قیمت
                    convertedPrice =
                        modalProduct.roundingType === "up"
                            ? Math.ceil(convertedPrice / modalProduct.roundingValue) * modalProduct.roundingValue
                            : modalProduct.roundingType === "down"
                                ? Math.floor(convertedPrice / modalProduct.roundingValue) * modalProduct.roundingValue
                                : Math.round(convertedPrice / modalProduct.roundingValue) * modalProduct.roundingValue;

                    // جایگزینی مقدار نهایی قیمت محاسبه‌شده
                    value.priceModifier = convertedPrice;
                }
            });

            // محاسبه Base Price فقط از مقادیر `base`
            const baseValues = option.values.filter((v: any) => v.type === "base");
            if (baseValues.length > 0) {
                let minPrice = Math.min(...baseValues.map((v: any) => v.priceModifier));
                basePrice += minPrice;
            }
        });

        // آپدیت مقدار `modalProduct`
        setModalProduct((prev: any) => ({
            ...prev,
            options: updatedOptions, // ذخیره تغییرات در `options`
            price: basePrice, // قیمت نهایی
        }));
    };


    // usdt نرخ برای محصولات تک
    const calculateFinalPrice = () => {

        setIsCalcLoading(true)

        let basePrice = parseFloat(modalProduct.price) || 0;
        const usdtRate = modalProduct.usdtBaseRate || 1;
        const multiplier = modalProduct.multiplier || 1;
        const profitMargin = modalProduct.profitMargin || 0;
        const feePercentage = modalProduct.feePercentage || 0;
        const minRate = modalProduct.minRate || 0;

        // محاسبه قیمت اولیه
        let finalPrice = (basePrice * usdtRate * multiplier);
        const initialPrice = finalPrice;

        // اعمال سود
        const profitAmount = (finalPrice * profitMargin) / 100;
        finalPrice += profitAmount;

        // اعمال کارمزد
        const feeAmount = (finalPrice * feePercentage) / 100;
        finalPrice += feeAmount;

        // بررسی حداقل قیمت
        if (finalPrice < minRate) finalPrice = minRate;

        // گرد کردن قیمت
        const roundedPrice =
            modalProduct.roundingType === "up"
                ? Math.ceil(finalPrice / modalProduct.roundingValue) * modalProduct.roundingValue
                : modalProduct.roundingType === "down"
                    ? Math.floor(finalPrice / modalProduct.roundingValue) * modalProduct.roundingValue
                    : Math.round(finalPrice / modalProduct.roundingValue) * modalProduct.roundingValue;

        setModalProduct((prev: any) => ({
            ...prev,
            usdtprice: basePrice,
            price: roundedPrice,
        }));
        setIsCalcLoading(false)

        setPriceDetails(`
            محاسبه قیمت اولیه: ${initialPrice.toLocaleString()} تومان
            اضافه کردن سود (${profitMargin}%): ${profitAmount.toLocaleString()}
            اضافه کردن کارمزد (${feePercentage}%): ${feeAmount.toLocaleString()}
            حداقل قیمت: ${minRate.toLocaleString()} تومان
            قیمت نهایی: ${finalPrice.toLocaleString()} تومان
            قیمت گرد شده: ${roundedPrice.toLocaleString()} تومان
        `);

        setIsCalcLoading(false)

    };



    const handleSave = async () => {
        setIsLoading(true);

        const formData = new FormData();
        formData.append("title", modalProduct.title);
        formData.append("name", modalProduct.name);

        formData.append("genre", modalProduct.genre);
        formData.append("year", modalProduct.year);
        formData.append("company", modalProduct.company);
        formData.append("stock", modalProduct.stock);
        formData.append("description", modalProduct.description);


        formData.append("tags", modalProduct.tags);

        (modalProduct.images || []).forEach((image: File, index: number) => {
            formData.append(`productImage${index}`, image);
        });

        if (modalProduct.coverImage) {
            formData.append("coverImage", modalProduct.coverImage);
        }


        formData.append("categoryParent", modalProduct.categoryParent);
        formData.append("categoryChild", modalProduct.categoryChild);


        const updatedProduct = {
            ...modalProduct,
            reviews: {
                ...modalProduct.reviews,
                rating: modalProduct.reviews.rating || 0,
                reviewsCount: modalProduct.reviews.reviewsCount || 0,
                enableReviews: modalProduct.reviews.enableReviews || false,
            },
            stock: {
                ...modalProduct.stock,
                quantity: modalProduct.stock.quantity || 0,
                status: modalProduct.stock.status || "automatic",
                autoCheck: modalProduct.stock.autoCheck || false,
                limitPurchase: modalProduct.stock.limitPurchase || false,
                maxLimit: modalProduct.stock.maxLimit || null,
            },
            discount: {
                ...modalProduct.discount,
                startAt: date[0] || modalProduct.discount.startAt,
                expiresAt: date[1] || modalProduct.discount.expiresAt,
            },
        };

        setTimeout(() => {
            toast.success("تغییرات با موفقیت ذخیره شد");
            setIsLoading(false);
            setProduct(updatedProduct);
        }, 1000);
    };



    const addOption = () => {
        setModalProduct({
            ...modalProduct,
            options: [...modalProduct.options, { name: "", values: [{ label: "", priceModifier: 0 }] }],
        });
    };

    const updateOption = (index: any, key: any, value: any) => {
        const newOptions = [...modalProduct.options];
        newOptions[index][key] = value;
        setModalProduct({ ...modalProduct, options: newOptions });
    };

    const addOptionValue = (index: any) => {
        const newOptions = [...modalProduct.options];
        newOptions[index].values.push({
            label: "",
            priceModifier: 0,
            type: "extra", // پیش‌فرض نوع extra
            applyRateToValue: true, // پیش‌فرض محاسبه بر اساس نرخ USDT
            hasMinimumPrice: false,
            minimumPriceModifier: 0
        });
        setModalProduct({ ...modalProduct, options: newOptions });
    };

    const updateOptionValue = (optIndex: any, valIndex: any, key: any, value: any) => {
        const newOptions = [...modalProduct.options];
        newOptions[optIndex].values[valIndex][key] = value;
        setModalProduct({ ...modalProduct, options: newOptions });
    };

    const removeOption = (index: any) => {
        const newOptions = modalProduct.options.filter((_: any, i: any) => i !== index);
        setModalProduct({ ...modalProduct, options: newOptions });
    };





    const handleNerkhChange = (selectedId: string | null) => {
        setSelectedNerkh(selectedId);

        const selectedData: any = nerkhList.find((nerkh: any) => nerkh._id === selectedId);
        setSelectedNerkhData(selectedData || null);
        setModalProduct((prev: any) => ({
            ...prev,
            minRate: modalProduct.minRate || 0,
            profitMargin: selectedData.profitMargin || 0,
            feePercentage: selectedData.feePercentage || 0,
            multiplier: selectedData.multiplier || 1,
            roundingType: selectedData.roundingType || "nearest",
            roundingValue: selectedData.roundingValue || 0,
            usdtBaseRate: selectedData.usdtBaseRate || 0,
        }));
    };

    useEffect(() => {
        if (hasOption) {
            if (selectedNerkhData) {
                setModalProduct((prev: any) => ({
                    ...prev,
                    nerkhId: selectedNerkhData._id,
                }));
            }
            calculateOptionPrice();
        } else {
            if (selectedNerkhData) {
                setModalProduct((prev: any) => ({
                    ...prev,
                    nerkhId: selectedNerkhData._id,
                }));
            }

            calculateFinalPrice();
        }
    }, [selectedNerkh]);

    const nerkhOptions = nerkhList.map((nerkh: any) => ({
        value: nerkh._id,
        label: nerkh.nerkhName,
        description: `ضریب: ${nerkh.multiplier}، سود: ${nerkh.profitMargin}، کارمزد: ${nerkh.feePercentage}، مدل گرد: ${formatNerkh[nerkh.roundingType]}`,
    }));

    const inventoryOptions = invetories.map((inventory: any) => ({
        value: inventory._id,
        label: inventory.name,
        description: `تعداد کلید ها: ${inventory?.keys.length}`,
    }));
    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>

            <DialogContent showCloseButton={false} className="w-full max-w-4xl bg-[#1A1525] text-white p-4 rounded-xl border-none">
                <div className="fixed -top-16 inset-x-0 bg-[#1A1525] px-3 py-2 rounded-xl">
                    <Steper steps={steps} activeStep={currentStep} />
                </div>
                <DialogTitle className="space-y-2">
                    <p>اضافه کردن محصول</p>
                    <p className="text-xs font-normal">از طریق این فرم شما می توانید محصول جدید اضافه کنید</p>
                </DialogTitle>

                <div className="space-y-4">
                    {currentStep === 1 && (
                        <div className="grid grid-cols-2 gap-3">
                            <div>
                                <label className="text-sm">عنوان محصول</label>
                                <Input value={modalProduct.title} onChange={(e) => setModalProduct({ ...modalProduct, title: e.target.value })} />
                            </div>
                            <div>
                                <label className="text-sm">نام محصول</label>
                                <Input value={modalProduct.name} onChange={(e) => setModalProduct({ ...modalProduct, name: e.target.value })} />
                            </div>

                            <div>
                                <label className="text-sm">سال انتشار</label>
                                <Input value={modalProduct.year} onChange={(e) => setModalProduct({ ...modalProduct, year: e.target.value })} />
                            </div>

                            <div>
                                <label className="text-sm">شرکت سازنده</label>
                                <Input value={modalProduct.company} onChange={(e) => setModalProduct({ ...modalProduct, company: e.target.value })} />
                            </div>

                            <div>
                                <TagInputs
                                    tags={modalProduct.genre || []}
                                    setTags={(newTags: any) => {
                                        const stringTags = newTags.map((tag: any) => (typeof tag === "object" ? tag.text : tag));
                                        setModalProduct({ ...modalProduct, genre: stringTags });
                                    }}
                                    label={'لیست ژانر محصول'}
                                    placeholder={'ژانر وارد کنید'}
                                />

                            </div>

                            <div className="col-span-1">
                                <label className="text-sm">آدرس slug</label>
                                <Input value={modalProduct.slug} onChange={(e) => setModalProduct({ ...modalProduct, slug: e.target.value })} />
                            </div>

                            {/* <div>
                                <TagInputs
                                    tags={modalProduct.tags || []}
                                    setTags={(newTags: any) => {
                                        const stringTags = newTags.map((tag: any) => (typeof tag === "object" ? tag.text : tag));
                                        setModalProduct({ ...modalProduct, tags: stringTags });
                                    }}
                                    label={'برچسب های محصول'}
                                    placeholder={'لیست برچسب را وارد کن'}
                                />

                            </div> */}

                            <div className="col-span-2">
                                <label>توضیحات کوتاه</label>
                                <Textarea
                                    value={modalProduct.description}
                                    onChange={(e) => setModalProduct({ ...modalProduct, description: e.target.value })}
                                    placeholder="توضیحات کوتاه درمورد محصول خود بنویس."
                                />
                            </div>

                        </div>
                    )}

                    {currentStep === 2 && (
                        <div className="w-full space-y-4 px-4 py-4 bg-[#120D1B] rounded-xl border-2 border-[#2D1B54]">
                            <div className="flex flex-col gap-2">
                                <p className="text-sm">آپلود تصاویر محصول</p>
                                <div className="grid grid-cols-8 gap-2 w-full">
                                    {(modalProduct.images || []).map((image: File | string, index: number) => (
                                        <div key={index} className="relative group">
                                            <img
                                                src={
                                                    image instanceof File
                                                        ? URL.createObjectURL(image)
                                                        : image
                                                }
                                                alt={`Product image ${index + 1}`}
                                                className="aspect-square w-20 h-20 rounded-md object-cover group-hover:opacity-80 transition-opacity"
                                            />
                                            <Button
                                                variant="ghost"
                                                size="sm"
                                                className="absolute w-6 h-6 top-1 right-1 bg-background/80 hover:bg-background"
                                                onClick={() => handleRemoveProductImage(index)}
                                            >
                                                <XIcon className="w-4 h-4 text-muted-foreground" />
                                            </Button>
                                        </div>
                                    ))}

                                    <div className="relative group">
                                        <label className="flex aspect-square w-20 h-20 items-center justify-center rounded-md border-2 border-dashed border-[#30323F] hover:border-[#343944] bg-muted/10 hover:bg-muted/20 transition-colors cursor-pointer">
                                            <PlusIcon className="w-6 h-6 text-muted-foreground" />
                                            <input type="file" multiple accept="image/*" onChange={handleProductImageUpload} className="hidden" />
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="relative group">
                                {modalProduct.coverImage ? (
                                    <>
                                        <img
                                            src={
                                                modalProduct.coverImage instanceof File
                                                    ? URL.createObjectURL(modalProduct.coverImage)
                                                    : modalProduct.coverImage || "/images/default-cover.jpg"
                                            }
                                            alt="Cover image"
                                            className="aspect-[5/2] w-full rounded-md object-cover group-hover:opacity-80 transition-opacity"
                                        />

                                        <Button
                                            variant="ghost"
                                            size='sm'
                                            className="absolute w-6 h-6 top-1 right-1 bg-background/80 hover:bg-background"
                                            onClick={handleRemoveCoverImage}
                                        >
                                            <XIcon className="w-4 h-4 text-muted-foreground" />
                                        </Button>
                                    </>
                                ) : (
                                    <label className="flex aspect-[5/2] w-full items-center justify-center rounded-lg border-2 border-dashed border-[#30323F] hover:border-[#343944] bg-muted/10 hover:bg-muted/20 transition-colors cursor-pointer">
                                        <div className='flex flex-col gap-3 items-center'>
                                            <PlusIcon className="w-6 h-6 text-muted-foreground" />
                                            <p className='text-[#5d6169] text-sm'>کاور محصول را اینجا آپلود کنید</p>
                                        </div>
                                        <input type="file" accept="image/*" onChange={handleCoverImageUpload} className="hidden" />
                                    </label>
                                )}
                            </div>
                        </div>
                    )}

                    {currentStep === 3 && (
                        <Tabs defaultValue="tab-1">
                            <ScrollArea>
                                <TabsList className="mb-3 w-full">
                                    <TabsTrigger value="tab-1">
                                        <Icons.price className="-ms-0.5 me-1.5 w-5 h-5 opacity-60" />
                                        قیمت
                                    </TabsTrigger>
                                    <TabsTrigger value="tab-2" className="group">
                                        <Icons.delivery className="-ms-0.5 me-1.5 w-5 h-5 opacity-60" />
                                        روش تحویل
                                    </TabsTrigger>
                                    <TabsTrigger value="tab-3" className="group">
                                        <Icons.box className="-ms-0.5 me-1.5 w-5 h-5 opacity-60" />
                                        موجودی
                                        {/* <Badge className="ms-1.5 transition-opacity group-data-[state=inactive]:opacity-50">
                                            New
                                        </Badge> */}
                                    </TabsTrigger>
                                    <TabsTrigger value="tab-4" className="group">
                                        <Icons.texting className="-ms-0.5 me-1.5 w-5 h-5 opacity-60" />
                                        بخش نظرات
                                    </TabsTrigger>
                                    <TabsTrigger value="tab-5" className="group">
                                        <Icons.library className="-ms-0.5 me-1.5 w-5 h-5 opacity-60" />
                                        دسته بندی
                                    </TabsTrigger>
                                    <TabsTrigger value="tab-6" className="group">
                                        <Icons.lab className="-ms-0.5 me-1.5 w-5 h-5 opacity-60" />
                                        سئو
                                    </TabsTrigger>
                                    <TabsTrigger disabled value="tab-7" className="group">
                                        <Icons.lab className="-ms-0.5 me-1.5 w-5 h-5 opacity-60" />
                                        آزمایشی
                                    </TabsTrigger>
                                </TabsList>
                                <ScrollBar orientation="horizontal" />
                            </ScrollArea>
                            <TabsContent value="tab-1" className="h-[500px]">
                                <ScrollArea className="h-[470px] px-4">
                                    <div className="grid grid-cols-2 gap-5">
                                        {/* general settings */}
                                        <div className="flex flex-col gap-5">
                                            <div className="bg-[#120D1B] rounded-xl border-[1px] border-[#2F1C55]">
                                                <p className="text-xs px-3 text-[#b69ceb] pt-2">تنظیمات عمومی</p>
                                                {/* price */}
                                                <div className="p-3 flex flex-col">
                                                    <label className="text-sm">قیمت محصول</label>
                                                    <div className="relative flex rounded-md shadow-xs">
                                                        <Input
                                                            disabled={hasOption}
                                                            value={modalProduct.price || 0} onChange={(e) => setModalProduct({ ...modalProduct, price: e.target.value })}
                                                            placeholder="با توجه به نرخ مشخص شده وارد کنید"
                                                            type="text"
                                                        />

                                                    </div>
                                                </div>

                                                {/*  Minimum Price */}
                                                {isAutoPriceChecked && !hasOption && (
                                                    <div className="p-3 flex flex-col">
                                                        <label className="text-sm">حداقل قیمت</label>
                                                        <div className="relative flex rounded-md shadow-xs">
                                                            <Input
                                                                disabled={hasOption}
                                                                value={modalProduct.minRate} onChange={(e) => setModalProduct({ ...modalProduct, minRate: e.target.value })}
                                                                placeholder="حداقل قیمت را به تومان وارد کنید"
                                                                type="text"
                                                            />

                                                        </div>
                                                    </div>
                                                )}

                                                {/* auto price */}
                                                <div className="px-3 pb-3">
                                                    <div
                                                        className={`border-input relative flex w-full items-start gap-2 rounded-md border p-4 shadow-xs outline-none transition-all ${isAutoPriceChecked ? "border-ring" : ""
                                                            }`}
                                                    >
                                                        <Switch
                                                            checked={isAutoPriceChecked}
                                                            onCheckedChange={(value) => {
                                                                setIsAutoPriceChecked(value);
                                                                setModalProduct((prev: any) => ({
                                                                    ...prev,
                                                                    currency: value ? "USDT" : "IRT",
                                                                    autoPriceEnabled: value ? true : false,
                                                                }));
                                                            }}
                                                            className="order-1 h-4 w-6 after:absolute after:inset-0 [&_span]:size-3 data-[state=checked]:[&_span]:translate-x-0 data-[state=checked]:rtl:-translate-x-2"
                                                        />


                                                        <div className="flex grow items-center gap-3">
                                                            <Icons.scan className="w-10 h-10 opacity-60" />
                                                            <div className="grid grow gap-2">
                                                                <label className="flex items-center justify-end flex-row-reverse gap-2">
                                                                    قیمت بر حسب دلار
                                                                </label>
                                                                <p className="text-muted-foreground text-xs">
                                                                    برای آپدیت شدن قیمت با توجه به usdt
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="px-3 pb-3">
                                                    <div
                                                        className={`border-input relative flex w-full items-start gap-2 rounded-md border p-4 shadow-xs outline-none transition-all ${hasOption ? "border-ring" : ""
                                                            }`}
                                                    >
                                                        <Switch
                                                            checked={hasOption}
                                                            onCheckedChange={(value) => {
                                                                setHasOption(value);
                                                                if (value) {
                                                                    setModalProduct({
                                                                        ...modalProduct,
                                                                        priceCalculationMode: "option-based"
                                                                    })
                                                                } else {
                                                                    setModalProduct({
                                                                        ...modalProduct,
                                                                        priceCalculationMode: "static"
                                                                    })
                                                                }
                                                            }}
                                                            className="order-1 h-4 w-6 after:absolute after:inset-0 [&_span]:size-3 data-[state=checked]:[&_span]:translate-x-0 data-[state=checked]:rtl:-translate-x-2"
                                                        />


                                                        <div className="flex grow items-center gap-3">
                                                            <Icons.scan className="w-10 h-10 opacity-60" />
                                                            <div className="grid grow gap-2">
                                                                <label className="flex items-center justify-end flex-row-reverse gap-2">
                                                                    آپشن محصول
                                                                </label>
                                                                <p className="text-muted-foreground text-xs">
                                                                    اضافه کردن آپشن محصول
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>



                                            {/* add options for product */}
                                            {hasOption && (
                                                <div className="bg-[#120D1B] rounded-xl border-[1px] border-[#2F1C55]">
                                                    <p className="text-xs px-3 text-[#b69ceb] pt-2">اضافه کردن آپشن محصول</p>
                                                    <div className="p-3 flex flex-col gap-3">
                                                        {modalProduct.options.map((option: any, index: any) => (
                                                            <div key={index} className="w-full flex flex-col p-3 gap-2 rounded-xl border-[1px] border-[#1F1339]">
                                                                <Button variant="subtle" className="bg-[#b313131e] hover:bg-[#b313132c] opacity-100" onClick={() => removeOption(index)}>حذف</Button>
                                                                <Input value={option.name} onChange={(e) => updateOption(index, "name", e.target.value)} placeholder="نام آپشن مادر (مثلاً ریجن)" />
                                                                {option.values.map((value: any, valIndex: any) => (
                                                                    <div key={valIndex} className="grid grid-cols-2 gap-2 items-center">
                                                                        <div>
                                                                            <Input
                                                                                value={value.label}
                                                                                onChange={(e) => updateOptionValue(index, valIndex, "label", e.target.value)}
                                                                                placeholder="آپشن فرزند (مثلا ترکیه)"
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <Input
                                                                                className="[&::-webkit-inner-spin-button]:appearance-none"
                                                                                type="number"
                                                                                value={value.priceModifier || null}
                                                                                onChange={(e) => updateOptionValue(index, valIndex, "priceModifier", parseInt(e.target.value))}
                                                                                placeholder="قیمت آپشن فرزند"
                                                                            />
                                                                        </div>

                                                                        <div className="flex gap-2">
                                                                            <div className="relative">
                                                                                <Switch
                                                                                    className="order-1 h-4 w-6 after:absolute after:inset-0 [&_span]:size-3 data-[state=checked]:[&_span]:translate-x-0 data-[state=checked]:rtl:-translate-x-2"
                                                                                    checked={value.type === "base"}
                                                                                    onCheckedChange={(checked) => updateOptionValue(index, valIndex, "type", checked ? "base" : "extra")}
                                                                                />
                                                                            </div>
                                                                            <span className="text-xs">{value.type === "base" ? "قیمت پایه" : "اضافه بها"}</span>
                                                                        </div>

                                                                        <div className="flex gap-2">
                                                                            <div className="relative">
                                                                                <Switch
                                                                                    className="order-1 h-4 w-6 after:absolute after:inset-0 [&_span]:size-3 data-[state=checked]:[&_span]:translate-x-0 data-[state=checked]:rtl:-translate-x-2"
                                                                                    checked={value.applyRateToValue}
                                                                                    onCheckedChange={(checked) => updateOptionValue(index, valIndex, "applyRateToValue", checked)}
                                                                                />
                                                                            </div>
                                                                            <span className="text-xs">{value.applyRateToValue ? "محاسبه با USDT فعال" : "مقدار ثابت"}</span>
                                                                        </div>

                                                                        {/* سوییچ برای فعال‌سازی حداقل قیمت */}
                                                                        <div className="relative flex items-center gap-2">
                                                                            <Switch
                                                                                className="order-1 h-4 w-6 after:absolute after:inset-0 [&_span]:size-3 data-[state=checked]:[&_span]:translate-x-0 data-[state=checked]:rtl:-translate-x-2"
                                                                                checked={value.hasMinimumPrice}
                                                                                onCheckedChange={(checked) => updateOptionValue(index, valIndex, "hasMinimumPrice", checked)}
                                                                            />
                                                                            <span className="text-xs">{value.hasMinimumPrice ? "حداقل قیمت فعال" : "حداقل قیمت غیر فعال"}</span>
                                                                        </div>

                                                                        {value.hasMinimumPrice && (
                                                                            <div className="col-span-2">
                                                                                <Input
                                                                                    className="[&::-webkit-inner-spin-button]:appearance-none"
                                                                                    type="number"
                                                                                    value={value.minimumPriceModifier || ""}
                                                                                    onChange={(e) =>
                                                                                        updateOptionValue(index, valIndex, "minimumPriceModifier", parseInt(e.target.value))
                                                                                    }
                                                                                    placeholder="حداقل قیمت برای این آپشن"
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                                <Button variant='subtle' onClick={() => addOptionValue(index)} className="mt-2">افزودن مقدار جدید</Button>
                                                            </div>
                                                        ))}
                                                        <Button variant='subtle' onClick={addOption} className="mt-2">افزودن گزینه</Button>
                                                    </div>
                                                </div>
                                            )}

                                            {priceDetails && !hasOption && (
                                                <>
                                                    {modalProduct.roundingType !== "" && (
                                                        <div className="bg-[#120D1B] rounded-xl border-[1px] border-[#2F1C55]">
                                                            <div></div>
                                                            <p className="text-xs px-3 text-[#b69ceb] pt-2">اضافه کردن آپشن محصول</p>
                                                            <div className="p-3 flex flex-col gap-3 text-sm">
                                                                <div className="flex items-center justify-start gap-2">
                                                                    <DollarSign className="w-4 h-4 text-[#5E4F7C]" />
                                                                    <p className="text-gray-300">
                                                                        {priceDetails.split("\n")[1]}
                                                                    </p>
                                                                </div>

                                                                <div className="flex items-center justify-start gap-2">
                                                                    <Percent className="w-4 h-4 text-[#5E4F7C]" />
                                                                    <p className="text-gray-300">
                                                                        {priceDetails.split("\n")[2]}
                                                                    </p>
                                                                </div>

                                                                <div className="flex items-center justify-start gap-2">
                                                                    <TrendingUp className="w-4 h-4 text-[#5E4F7C]" />
                                                                    <p className="text-gray-300">
                                                                        {priceDetails.split("\n")[3]}
                                                                    </p>
                                                                </div>

                                                                <div className="flex items-center justify-start gap-2">
                                                                    <CheckCircle className="w-4 h-4 text-[#5E4F7C]" />
                                                                    <p className="text-gray-300">
                                                                        {priceDetails.split("\n")[4]}
                                                                    </p>
                                                                </div>

                                                                <div className="flex items-center justify-start gap-2">
                                                                    <DollarSign className="w-4 h-4 text-[#5E4F7C]" />
                                                                    <p className="text-gray-300">
                                                                        {priceDetails.split("\n")[5]}
                                                                    </p>
                                                                </div>


                                                                <div className="flex items-center justify-start gap-2">
                                                                    <PanelsTopLeftIcon className="w-4 h-4 text-[#5E4F7C]" />
                                                                    <p className="text-gray-300">
                                                                        {priceDetails.split("\n")[6]}
                                                                    </p>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>



                                        {/* percentage settings */}
                                        <div className="flex flex-col gap-5">
                                            <div className="bg-[#120D1B] rounded-xl border-[1px] border-[#2F1C55]">
                                                <p className="text-xs px-3 text-[#b69ceb] pt-2">تنظیمات حرفه ای</p>
                                                <div className="p-3 flex flex-col gap-3">
                                                    <div
                                                        className={`border-input relative flex w-full items-start gap-2 rounded-md border p-4 shadow-xs outline-none transition-all ${isOffPriceChecked ? "border-ring" : ""
                                                            }`}
                                                    >
                                                        <Switch
                                                            checked={isOffPriceChecked}
                                                            onCheckedChange={setIsOffPriceChecked}
                                                            className="order-1 h-4 w-6 after:absolute after:inset-0 [&_span]:size-3 data-[state=checked]:[&_span]:translate-x-0 data-[state=checked]:rtl:-translate-x-2"
                                                        />
                                                        <div className="flex grow items-center gap-3">
                                                            <Icons.offprice className="w-10 h-10 opacity-60" />
                                                            <div className="grid grow gap-2">
                                                                <label className="flex items-center justify-end flex-row-reverse gap-2">
                                                                    <span className="text-muted-foreground text-xs leading-[inherit] font-normal">
                                                                        (بعنوان تخفیف)
                                                                    </span>
                                                                    اعمال تخفیف
                                                                </label>
                                                                <p className="text-muted-foreground text-xs">
                                                                    برای مشخص کردن تخفیف فعال کنید
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {isOffPriceChecked && (
                                                        <div className="space-y-3">
                                                            <div>
                                                                <label className="text-sm">درصد تخفیف</label>
                                                                <Input
                                                                    value={modalProduct.discount.percentage} onChange={(e) =>
                                                                        setModalProduct({
                                                                            ...modalProduct,
                                                                            discount: {
                                                                                ...modalProduct.discount,
                                                                                percentage: e.target.value,
                                                                            },
                                                                        })
                                                                    }
                                                                    placeholder="درصد تخفیف را مشخص کنید" />
                                                            </div>


                                                            <div>
                                                                <Popover>
                                                                    <PopoverTrigger asChild>
                                                                        <Button
                                                                            id="date"
                                                                            variant={"subtle"}
                                                                            className={cn(
                                                                                "w-full justify-start text-left font-normal",
                                                                                !date && "text-muted-foreground"
                                                                            )}
                                                                        >
                                                                            <CalendarIcon />
                                                                            {date[0] ? (
                                                                                date[1] ? (
                                                                                    <>
                                                                                        {date[0].toString()} -{" "}
                                                                                        {date[1].toString()}
                                                                                    </>
                                                                                ) : (
                                                                                    date[0].toString()
                                                                                )
                                                                            ) : (
                                                                                <span>تاریخ را مشخص کنید</span>
                                                                            )}
                                                                        </Button>
                                                                    </PopoverTrigger>
                                                                    <PopoverContent className="w-auto p-0" align="start">
                                                                        <Calendar
                                                                            range
                                                                            calendar={persian}
                                                                            locale={persian_fa}
                                                                            value={date}
                                                                            numberOfMonths={2}
                                                                            onChange={handleDateChange}
                                                                        />
                                                                    </PopoverContent>
                                                                </Popover>


                                                            </div>
                                                        </div>
                                                    )}


                                                </div>
                                            </div>

                                            {/* usdt settings */}

                                            {isAutoPriceChecked && (
                                                <div className="bg-[#120D1B] rounded-xl border-[1px] border-[#2F1C55] relative">
                                                    <div className="absolute top-2 left-2">
                                                        <Button className="rounded-full" variant='subtle' onClick={() => {
                                                            setSelectedNerkh(null)
                                                            setModalProduct((prev: any) => ({
                                                                ...prev,
                                                                minRate: 0,
                                                                profitMargin: 0,
                                                                feePercentage: 0,
                                                                multiplier: 0,
                                                                roundingType: "",
                                                                roundingValue: 0,
                                                                usdtBaseRate: 0,
                                                                price: 0,
                                                                minmumprice: 0,
                                                            }));
                                                            toast.success('با موفقیت خالی شد.')
                                                        }} size='icon'>
                                                            <Icons.rubbish className="w-7 h-7" />
                                                        </Button>
                                                    </div>
                                                    <p className="text-xs px-3 text-[#b69ceb] pt-2">تنظیمات نرخ</p>
                                                    <div className="p-3 flex flex-col gap-3">
                                                        {nerkhList.length > 0 ? (
                                                            <DynamicSelect
                                                                label="انتخاب نرخ"
                                                                options={nerkhOptions}
                                                                placeholder="یک نرخ انتخاب کنید"
                                                                selectedValue={selectedNerkh}
                                                                setSelectedValue={handleNerkhChange}
                                                            />
                                                        ) : (
                                                            <div className="w-full h-full flex justify-center items-center text-center">
                                                                {nerkhLoading ? (
                                                                    <LoaderCircleIcon className="animate-spin" size={16} aria-hidden="true" />
                                                                ) : (
                                                                    <p className="text-gray-300 font-normal mb-5">هیچ نرخی وجود ندارد</p>
                                                                )}
                                                            </div>
                                                        )}
                                                        {/* نرخ USDT */}

                                                    </div>
                                                </div>
                                            )}


                                        </div>
                                    </div>
                                </ScrollArea>
                            </TabsContent>
                            <TabsContent value="tab-2">
                                <div className="grid grid-cols-2 gap-5">
                                    <div>
                                        <div className="bg-[#120D1B] rounded-xl border-[1px] border-[#2F1C55]">
                                            <p className="text-xs px-3 text-[#b69ceb] pt-2">تنظیمات عمومی</p>
                                            {/* price */}
                                            <div className="p-3 flex flex-col gap-3">
                                                <DynamicSelect
                                                    label="روش تحویل"
                                                    placeholder="روش تحویل محصول را مشخص کنید"
                                                    options={[
                                                        { value: "automatic", label: "خودکار", description: "تحویل بصورت خودکار از طریق سیستم" },
                                                        { value: "manual", label: "دستی", description: "تحویل توسط ادمین ها" },
                                                    ]}
                                                    selectedValue={modalProduct.deliveryMethod.toString()}
                                                    setSelectedValue={(value) =>
                                                        setModalProduct({ ...modalProduct, deliveryMethod: value })
                                                    }
                                                />

                                                {/* <DynamicSelect
                                                    label="جنس محصول"
                                                    placeholder="جنس محصول را مشخص کنید"
                                                    options={[
                                                        { value: "digital", label: "دیجیتالی", description: "مانند فایل، تصویر و ..." },
                                                        { value: "redeem_code", label: "ریدِم کد", description: "کد های یک بار مصرف بازی" },
                                                        { value: "physical", label: "فیزیکی", description: "اجناس فیزیکی مانند برد گیم یا مجسمه" },
                                                    ]}
                                                    selectedValue={modalProduct.type.toString()}
                                                    setSelectedValue={(value) =>
                                                        setModalProduct({ ...modalProduct, type: value })
                                                    }
                                                /> */}

                                                <div
                                                    className={`border-input relative flex w-full items-start gap-2 rounded-md border p-4 shadow-xs outline-none transition-all ${isRequiresUserInputChecked ? "border-ring" : ""
                                                        }`}
                                                >
                                                    <Switch
                                                        checked={isRequiresUserInputChecked}
                                                        onCheckedChange={(value) => {
                                                            setIsRequiresUserInputChecked(value);
                                                            setModalProduct((prev: any) => ({
                                                                ...prev,
                                                                requiresUserInput: value,
                                                            }));
                                                        }}
                                                        className="order-1 h-4 w-6 after:absolute after:inset-0 [&_span]:size-3 data-[state=checked]:[&_span]:translate-x-0 data-[state=checked]:rtl:-translate-x-2"
                                                    />


                                                    <div className="flex grow items-center gap-3">
                                                        {/* <Icons.earth className="w-20 h-20 opacity-60" /> */}
                                                        <div className="grid grow gap-2">
                                                            <label className="flex items-center justify-end flex-row-reverse gap-2">
                                                                {/* <span className="text-muted-foreground text-xs leading-[inherit] font-normal">
                                                                </span> */}
                                                                دریافت ورودی از کاربر
                                                            </label>
                                                            <p className="text-muted-foreground text-xs">
                                                                در صفحه محصول از کاربر ورودی دریافت می شود مثل آیدی درون بازی
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {modalProduct.deliveryMethod === 'automatic' && (
                                                    <DynamicSelect
                                                        label="انتخاب خزانه"
                                                        placeholder="خزانه مورد نظر خود را انتخاب کنید"
                                                        options={inventoryOptions}
                                                        selectedValue={selectedInventory}
                                                        setSelectedValue={(value) => {
                                                            setSelectedInventory(value)
                                                            setModalProduct((prev: any) => ({
                                                                ...prev,
                                                                inventoryId: value,
                                                            }));
                                                        }
                                                        }
                                                    />
                                                )}

                                                {/* {modalProduct.type === 'digital' && (
                                                    <div className="relative group">
                                                        {modalProduct.file ? (
                                                            <>
                                                                <div className="relative flex flex-col items-center justify-center aspect-[5/2] w-full rounded-md bg-[#30323F]/20 border-2 border-dashed border-[#30323F] p-4">
                                                                    <img
                                                                        src='/images/zip.png'
                                                                        alt="zip file"
                                                                        width={50}
                                                                        height={50}
                                                                    />
                                                                    <p className="text-xs text-white mt-2">{modalProduct.file.name}</p>

                                                                    <Button
                                                                        variant="ghost"
                                                                        size='sm'
                                                                        className="absolute w-6 h-6 top-1 right-1 bg-background/80 hover:bg-background"
                                                                        onClick={handleRemoveFile}
                                                                    >
                                                                        <XIcon className="w-4 h-4 text-muted-foreground" />
                                                                    </Button>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <label className="flex aspect-[5/2] w-full items-center justify-center rounded-lg border-2 border-dashed border-[#30323F] hover:border-[#343944] bg-muted/10 hover:bg-muted/20 transition-colors cursor-pointer">
                                                                <div className='flex flex-col gap-3 items-center'>
                                                                    <PlusIcon className="w-6 h-6 text-muted-foreground" />
                                                                    <p className='text-[#5d6169] text-sm'>فایل ZIP را آپلود کنید</p>
                                                                </div>
                                                                <input type="file" accept=".zip" onChange={handleProductFileUpload} className="hidden" />
                                                            </label>
                                                        )}
                                                    </div>
                                                )} */}


                                            </div>


                                        </div>
                                    </div>

                                    <div>
                                        <div className="bg-[#120D1B] rounded-xl border-[1px] border-[#2F1C55]">
                                            <p className="text-xs px-3 text-[#b69ceb] pt-2">تنظیمات حرفه ای</p>
                                            {/* price */}
                                            <div className="p-3 space-y-3">
                                                <div
                                                    className={`border-input relative flex w-full items-start gap-2 rounded-md border p-4 shadow-xs outline-none transition-all ${isAutoPriceChecked ? "border-ring" : ""
                                                        }`}
                                                >
                                                    <Switch
                                                        disabled
                                                        checked={true}
                                                        className="order-1 h-4 w-6 after:absolute after:inset-0 [&_span]:size-3 data-[state=checked]:[&_span]:translate-x-0 data-[state=checked]:rtl:-translate-x-2"
                                                    />
                                                    <div className="flex grow items-center gap-3">
                                                        <Icons.email className="w-20 h-20 opacity-60" />
                                                        <div className="grid grow gap-2">
                                                            <label className="flex items-center justify-end flex-row-reverse gap-2">
                                                                {/* <span className="text-muted-foreground text-xs leading-[inherit] font-normal">
                                                                </span> */}
                                                                تحویل از طریق ایمیل
                                                            </label>
                                                            <p className="text-muted-foreground text-xs">
                                                                در صورت پرداخت موفق، بصورت خودکار، کاربر از طریق ایمیل مطلع می شود
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    className={`border-input relative flex w-full items-start gap-2 rounded-md border p-4 shadow-xs outline-none transition-all ${isAutoPriceChecked ? "border-ring" : ""
                                                        }`}
                                                >
                                                    <Switch
                                                        disabled
                                                        checked={true}
                                                        className="order-1 h-4 w-6 after:absolute after:inset-0 [&_span]:size-3 data-[state=checked]:[&_span]:translate-x-0 data-[state=checked]:rtl:-translate-x-2"
                                                    />
                                                    <div className="flex grow items-center gap-3">
                                                        <Icons.message className="w-20 h-20 opacity-60" />
                                                        <div className="grid grow gap-2">
                                                            <label className="flex items-center justify-end flex-row-reverse gap-2">
                                                                {/* <span className="text-muted-foreground text-xs leading-[inherit] font-normal">
                                                                </span> */}
                                                                تحویل از طریق sms
                                                            </label>
                                                            <p className="text-muted-foreground text-xs">
                                                                در صورت پرداخت موفق، بصورت خودکار، کاربر از طریق sms مطلع می شود
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    className={`border-input relative flex w-full items-start gap-2 rounded-md border p-4 shadow-xs outline-none transition-all ${isAutoPriceChecked ? "border-ring" : ""
                                                        }`}
                                                >
                                                    <Switch
                                                        checked={true}
                                                        className="order-1 h-4 w-6 after:absolute after:inset-0 [&_span]:size-3 data-[state=checked]:[&_span]:translate-x-0 data-[state=checked]:rtl:-translate-x-2"
                                                    />
                                                    <div className="flex grow items-center gap-3">
                                                        <Icons.earth className="w-20 h-20 opacity-60" />
                                                        <div className="grid grow gap-2">
                                                            <label className="flex items-center justify-end flex-row-reverse gap-2">
                                                                {/* <span className="text-muted-foreground text-xs leading-[inherit] font-normal">
                                                                </span> */}
                                                                تحویل از طریق سایت
                                                            </label>
                                                            <p className="text-muted-foreground text-xs">
                                                                در صورت پرداخت موفق، بصورت خودکار، کاربر از طریق سایت مطلع خواهد شد
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </TabsContent>
                            <TabsContent value="tab-3">
                                <div className="grid grid-cols-2 gap-5">
                                    <div>
                                        <div className="bg-[#120D1B] rounded-xl border-[1px] border-[#2F1C55]">
                                            <p className="text-xs px-3 text-[#b69ceb] pt-2">تنظیمات عمومی</p>
                                            <div className="p-3 flex flex-col gap-3">
                                                <DynamicSelect
                                                    label="وضعیت موجودی"
                                                    placeholder="وضعیت موجودی را مشخص کنید"
                                                    options={[
                                                        { value: "automatic", label: "موجود", description: "" },
                                                        { value: "manual", label: "اتمام", description: "" },
                                                        { value: "test", label: "در انتظار موجود شدن", description: "" },
                                                    ]}
                                                    selectedValue={modalProduct.stock.status}
                                                    setSelectedValue={(value) =>
                                                        setModalProduct((prev: any) => ({
                                                            ...prev,
                                                            stock: {
                                                                ...prev.stock,
                                                                status: value,
                                                            },
                                                        }))
                                                    }
                                                />

                                                <div
                                                    className={`border-input relative flex w-full items-start gap-2 rounded-md border p-4 shadow-xs outline-none transition-all ${isOffPriceChecked ? "border-ring" : ""
                                                        }`}
                                                >
                                                    <Switch
                                                        checked={modalProduct.stock.autoCheck}
                                                        onCheckedChange={(value) => {
                                                            setModalProduct((prev: any) => ({
                                                                ...prev,
                                                                stock: {
                                                                    ...prev.stock,
                                                                    autoCheck: value,
                                                                },
                                                            }));
                                                        }}
                                                        className="order-1 h-4 w-6 after:absolute after:inset-0 [&_span]:size-3 data-[state=checked]:[&_span]:translate-x-0 data-[state=checked]:rtl:-translate-x-2"
                                                    />
                                                    <div className="flex grow items-center gap-3">
                                                        <div className="grid grow gap-2">
                                                            <label className="flex items-center justify-end flex-row-reverse gap-2">
                                                                <span className="text-muted-foreground text-xs leading-[inherit] font-normal">
                                                                    (بصورت خودکار)
                                                                </span>
                                                                برسی موجودی
                                                            </label>
                                                            <p className="text-muted-foreground text-xs">
                                                                برسی موجودی بصورت خودکار
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>



                                            </div>
                                        </div>
                                    </div>


                                    <div>
                                        <div className="bg-[#120D1B] rounded-xl border-[1px] border-[#2F1C55]">
                                            <p className="text-xs px-3 text-[#b69ceb] pt-2">تنظیمات حرفه ای</p>
                                            {/* price */}
                                            <div className="p-3 flex flex-col gap-3">
                                                <div
                                                    className={`border-input relative flex w-full items-start gap-2 rounded-md border p-4 shadow-xs outline-none transition-all ${modalProduct.stock.limitPurchase ? "border-ring" : ""
                                                        }`}
                                                >
                                                    <Switch
                                                        checked={modalProduct.stock.limitPurchase}
                                                        onCheckedChange={(value) => {
                                                            setModalProduct((prev: any) => ({
                                                                ...prev,
                                                                stock: {
                                                                    ...prev.stock,
                                                                    limitPurchase: value,
                                                                },
                                                            }));
                                                        }}
                                                        className="order-1 h-4 w-6 after:absolute after:inset-0 [&_span]:size-3 data-[state=checked]:[&_span]:translate-x-0 data-[state=checked]:rtl:-translate-x-2"
                                                    />

                                                    <div className="flex grow items-center gap-3">
                                                        <div className="grid grow gap-2">
                                                            <label className="flex items-center justify-end flex-row-reverse gap-2">
                                                                اعمال محدودیت
                                                            </label>
                                                            <p className="text-muted-foreground text-xs">
                                                                درصورت فعال کردن، تعداد محدود از کاربران می توانند این محصول را خریداری کنند
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {modalProduct.stock.limitPurchase && (
                                                    <div>
                                                        <label className="text-sm">مقدار محدودیت</label>
                                                        <Input
                                                            value={modalProduct.stock.maxLimit || ""}
                                                            onChange={(e) =>
                                                                setModalProduct((prev: any) => ({
                                                                    ...prev,
                                                                    stock: {
                                                                        ...prev.stock,
                                                                        maxLimit: e.target.value ? parseInt(e.target.value, 10) : null,
                                                                    },
                                                                }))
                                                            }
                                                            placeholder="مقدار محدود خریدی که در نظر دارید وارد کنید"
                                                        />

                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </TabsContent>
                            <TabsContent value="tab-4">
                                <div className="grid grid-cols-2 gap-5">
                                    <div>
                                        <div className="bg-[#120D1B] rounded-xl border-[1px] border-[#2F1C55]">
                                            <p className="text-xs px-3 text-[#b69ceb] pt-2">تنظیمات عمومی</p>
                                            <div className="p-3 flex flex-col gap-3">
                                                <div
                                                    className={`border-input relative flex w-full items-start gap-2 rounded-md border p-4 shadow-xs outline-none transition-all ${isOffPriceChecked ? "border-ring" : ""
                                                        }`}
                                                >
                                                    <Switch
                                                        checked={modalProduct.reviews.enableReviews}
                                                        onCheckedChange={(value) => {
                                                            setModalProduct((prev: any) => ({
                                                                ...prev,
                                                                reviews: {
                                                                    ...prev.reviews,
                                                                    enableReviews: value,
                                                                },
                                                            }));
                                                        }}
                                                        className="order-1 h-4 w-6 after:absolute after:inset-0 [&_span]:size-3 data-[state=checked]:[&_span]:translate-x-0 data-[state=checked]:rtl:-translate-x-2"
                                                    />
                                                    <div className="flex grow items-center gap-3">
                                                        <div className="grid grow gap-2">
                                                            <label className="flex items-center justify-end flex-row-reverse gap-2">
                                                                <span className="text-muted-foreground text-xs leading-[inherit] font-normal">
                                                                </span>
                                                                بخش نظرات
                                                            </label>
                                                            <p className="text-muted-foreground text-xs">
                                                                درصورت فعال، کاربر می تواند نظر خود را ثبت کند
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </TabsContent>


                            <TabsContent value="tab-5">
                                <div className="grid grid-cols-2 gap-5">
                                    <div className="space-y-4">
                                        <DynamicSelect
                                            label="دسته مادر"
                                            placeholder="دسته مادر را انتخاب کنید"
                                            options={categories.map((cat: any) => ({ value: cat.id, label: cat.name }))}
                                            selectedValue={selectedParentCategory}
                                            setSelectedValue={(value) => {

                                                const selectedCategory = categories.find((cat: any) => cat.id === value);


                                                setSelectedParentCategory(value);
                                                setSelectedChildCategory("");
                                                setModalProduct((prev: any) => ({
                                                    ...prev,
                                                    categoryParent: value,
                                                    categoryChild: "",
                                                    categoryParentName: selectedCategory?.name || "",
                                                    categoryChildName: "",
                                                }));
                                            }}
                                        />

                                        {selectedParentCategory && (
                                            <DynamicSelect
                                                label="دسته فرزند"
                                                placeholder="دسته فرزند را انتخاب کنید"
                                                options={
                                                    categories
                                                        .find((cat: any) => cat.id === selectedParentCategory)
                                                        ?.children?.map((child: any) => ({
                                                            value: child.id,
                                                            label: child.name,
                                                        })) || []
                                                }
                                                selectedValue={selectedChildCategory}
                                                setSelectedValue={(value) => {
                                                    if (!value) return;


                                                    const selectedChildCategory = categories.find((cat: any) => cat.id === value);
                                                    const parentCategory = categories.find((cat: any) => cat.id === selectedChildCategory?.parent);


                                                    setSelectedChildCategory(value);
                                                    setModalProduct((prev: any) => ({
                                                        ...prev,
                                                        categoryParent: selectedParentCategory,
                                                        categoryChild: value,
                                                        categoryParentName: parentCategory?.name || "",
                                                        categoryChildName: selectedChildCategory?.name || "",
                                                    }));
                                                }}
                                            />
                                        )}

                                        {isNewCategory ? (
                                            <div className="flex gap-3">
                                                <Input
                                                    placeholder="نام دسته جدید را وارد کنید"
                                                    value={newCategoryName}
                                                    onChange={(e) => setNewCategoryName(e.target.value)}
                                                />
                                                <Button
                                                    onClick={async () => {
                                                        try {
                                                            const response = await fetch("/api/category/create", {
                                                                method: "POST",
                                                                headers: { "Content-Type": "application/json" },
                                                                body: JSON.stringify({
                                                                    name: newCategoryName,
                                                                    parent: selectedParentCategory || null,
                                                                }),
                                                            });

                                                            if (!response.ok) {
                                                                throw new Error("خطا در ایجاد دسته!");
                                                            }

                                                            const newCategory = await response.json();

                                                            setCategories((prev: any) => [
                                                                ...prev,
                                                                {
                                                                    id: newCategory.category._id,
                                                                    name: newCategory.category.name,
                                                                    parent: newCategory.category.parent || null,
                                                                    children: [],
                                                                },
                                                            ]);

                                                            if (selectedParentCategory) {
                                                                setCategories((prev: any) =>
                                                                    prev.map((cat: any) =>
                                                                        cat.id === selectedParentCategory
                                                                            ? { ...cat, children: [...(cat.children || []), { id: newCategory.category._id, name: newCategory.category.name }] }
                                                                            : cat
                                                                    )
                                                                );

                                                                setSelectedChildCategory(newCategory.category._id);
                                                            } else {
                                                                setSelectedParentCategory(newCategory.category._id);
                                                            }

                                                            setModalProduct((prev: any) => ({
                                                                ...prev,
                                                                categoryParent: selectedParentCategory || newCategory.category._id,
                                                                categoryChild: selectedParentCategory ? newCategory.category._id : "",
                                                            }));

                                                            setIsNewCategory(false);
                                                            setNewCategoryName("");
                                                            toast.success("دسته جدید ایجاد شد!");
                                                        } catch (error) {
                                                            toast.error("خطا در ایجاد دسته!");
                                                        }
                                                    }}
                                                >
                                                    ایجاد
                                                </Button>
                                                <Button variant="outline" onClick={() => setIsNewCategory(false)}>
                                                    لغو
                                                </Button>
                                            </div>
                                        ) : (
                                            <span className="text-purple-500 cursor-pointer hover:underline" onClick={() => setIsNewCategory(true)}>
                                                ایجاد دسته جدید
                                            </span>
                                        )}
                                    </div>
                                </div>

                            </TabsContent>



                            <TabsContent value="tab-6">
                                <ScrollArea className="h-[500px] px-4">
                                    <div className="grid grid-cols-2 gap-5">
                                        {/* تنظیمات عمومی */}
                                        <div>
                                            <div className="bg-[#120D1B] rounded-xl border-[1px] border-[#2F1C55]">
                                                <p className="text-xs px-3 text-[#b69ceb] pt-2">تنظیمات عمومی</p>
                                                <div className="p-3 flex flex-col gap-3">
                                                    <label className="text-sm">فرمت محصول</label>
                                                    <Input
                                                        placeholder="مثلاً دیجیتال، فیزیکی، کد ریدیم"
                                                        value={modalProduct.metadata?.format || ""}
                                                        onChange={(e) =>
                                                            setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, format: e.target.value } })
                                                        }
                                                    />

                                                    <label className="text-sm">پلتفرم</label>
                                                    <Input
                                                        placeholder="مثلاً PS5, PC, Xbox"
                                                        value={modalProduct.metadata?.platform || ""}
                                                        onChange={(e) =>
                                                            setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, platform: e.target.value } })
                                                        }
                                                    />

                                                    <label className="text-sm">روش فعال‌سازی</label>
                                                    <Input
                                                        placeholder="مثلاً Steam, Epic, Uplay"
                                                        value={modalProduct.metadata?.activationMethod || ""}
                                                        onChange={(e) =>
                                                            setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, activationMethod: e.target.value } })
                                                        }
                                                    />

                                                    <label className="text-sm">زبان‌های پشتیبانی شده</label>
                                                    <TagInputs
                                                        tags={modalProduct.metadata?.supportedLanguages || []}
                                                        setTags={(newTags: any) => {
                                                            const stringTags = newTags.map((tag: any) => (typeof tag === "object" ? tag.text : tag));
                                                            setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, supportedLanguages: stringTags } });
                                                        }}
                                                        label="زبان‌های پشتیبانی شده"
                                                        placeholder="زبان جدید اضافه کنید"
                                                    />

                                                    <label className="text-sm">مناطق قابل‌دسترسی</label>
                                                    <TagInputs
                                                        tags={modalProduct.metadata?.regions || []}
                                                        setTags={(newTags: any) => {
                                                            const stringTags = newTags.map((tag: any) => (typeof tag === "object" ? tag.text : tag));
                                                            setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, regions: stringTags } });
                                                        }}
                                                        label="مناطق قابل‌دسترسی"
                                                        placeholder="منطقه جدید اضافه کنید"
                                                    />

                                                    <label className="text-sm">توضیحات ویژه</label>
                                                    <Textarea
                                                        placeholder="نکات مهم را اینجا وارد کنید"
                                                        value={modalProduct.metadata?.specialNotes || ""}
                                                        onChange={(e) =>
                                                            setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, specialNotes: e.target.value } })
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* تنظیمات حرفه‌ای */}
                                        <div>
                                            <div className="bg-[#120D1B] rounded-xl border-[1px] border-[#2F1C55]">
                                                <p className="text-xs px-3 text-[#b69ceb] pt-2">تنظیمات حرفه‌ای</p>
                                                <div className="p-3 flex flex-col gap-3">
                                                    <label className="text-sm">سیستم مورد نیاز</label>
                                                    <div className="grid grid-cols-2 gap-3">
                                                        <Input
                                                            placeholder="سیستم عامل (مثلاً Windows 10)"
                                                            value={modalProduct.metadata?.requirements?.os || ""}
                                                            onChange={(e) =>
                                                                setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, requirements: { ...modalProduct.metadata.requirements, os: e.target.value } } })
                                                            }
                                                        />
                                                        <Input
                                                            placeholder="پردازنده (مثلاً Intel i5 9600K)"
                                                            value={modalProduct.metadata?.requirements?.cpu || ""}
                                                            onChange={(e) =>
                                                                setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, requirements: { ...modalProduct.metadata.requirements, cpu: e.target.value } } })
                                                            }
                                                        />
                                                        <Input
                                                            placeholder="رم (مثلاً 16GB)"
                                                            value={modalProduct.metadata?.requirements?.ram || ""}
                                                            onChange={(e) =>
                                                                setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, requirements: { ...modalProduct.metadata.requirements, ram: e.target.value } } })
                                                            }
                                                        />
                                                        <Input
                                                            placeholder="کارت گرافیک (مثلاً RTX 3060)"
                                                            value={modalProduct.metadata?.requirements?.gpu || ""}
                                                            onChange={(e) =>
                                                                setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, requirements: { ...modalProduct.metadata.requirements, gpu: e.target.value } } })
                                                            }
                                                        />
                                                        <Input
                                                            placeholder="فضای مورد نیاز (مثلاً 50GB)"
                                                            value={modalProduct.metadata?.requirements?.storage || ""}
                                                            onChange={(e) =>
                                                                setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, requirements: { ...modalProduct.metadata.requirements, storage: e.target.value } } })
                                                            }
                                                        />
                                                    </div>

                                                    <label className="text-sm">ابعاد محصول (برای اجناس فیزیکی)</label>
                                                    <div className="grid grid-cols-3 gap-3">
                                                        <Input
                                                            placeholder="عرض (cm)"
                                                            value={modalProduct.metadata?.dimensions?.width || ""}
                                                            onChange={(e) =>
                                                                setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, dimensions: { ...modalProduct.metadata.dimensions, width: e.target.value } } })
                                                            }
                                                        />
                                                        <Input
                                                            placeholder="ارتفاع (cm)"
                                                            value={modalProduct.metadata?.dimensions?.height || ""}
                                                            onChange={(e) =>
                                                                setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, dimensions: { ...modalProduct.metadata.dimensions, height: e.target.value } } })
                                                            }
                                                        />
                                                        <Input
                                                            placeholder="عمق (cm)"
                                                            value={modalProduct.metadata?.dimensions?.depth || ""}
                                                            onChange={(e) =>
                                                                setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, dimensions: { ...modalProduct.metadata.dimensions, depth: e.target.value } } })
                                                            }
                                                        />
                                                    </div>

                                                    <label className="text-sm">گارانتی محصول</label>
                                                    <Input
                                                        placeholder="مثلاً 6 ماه"
                                                        value={modalProduct.metadata?.warranty || ""}
                                                        onChange={(e) =>
                                                            setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, warranty: e.target.value } })
                                                        }
                                                    />

                                                    <label className="text-sm">برچسب‌های محصول</label>
                                                    <TagInputs
                                                        tags={modalProduct.metadata?.tags || []}
                                                        setTags={(newTags: any) => {
                                                            const stringTags = newTags.map((tag: any) => (typeof tag === "object" ? tag.text : tag));
                                                            setModalProduct({ ...modalProduct, metadata: { ...modalProduct.metadata, tags: stringTags } });
                                                        }}
                                                        label="برچسب‌های محصول"
                                                        placeholder="برچسب جدید وارد کنید"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* تنظیمات سئو */}
                                    <div className="bg-[#120D1B] rounded-xl border-[1px] border-[#2F1C55] mt-5 p-3">
                                        <p className="text-xs px-3 text-[#b69ceb] pt-2">سئو و شبکه‌های اجتماعی</p>
                                        <div className="grid grid-cols-2 gap-3 p-3">
                                            {/* OG */}
                                            <div>
                                                <label className="text-sm">OG: عنوان</label>
                                                <Input
                                                    placeholder="عنوان OG برای شبکه‌های اجتماعی"
                                                    value={modalProduct.metadata?.og?.title || ""}
                                                    onChange={(e) =>
                                                        setModalProduct({
                                                            ...modalProduct,
                                                            metadata: {
                                                                ...modalProduct.metadata,
                                                                og: { ...modalProduct.metadata.og, title: e.target.value }
                                                            }
                                                        })
                                                    }
                                                />

                                                <label className="text-sm">OG: توضیحات</label>
                                                <Textarea
                                                    placeholder="توضیحات کوتاه برای OG"
                                                    value={modalProduct.metadata?.og?.description || ""}
                                                    onChange={(e) =>
                                                        setModalProduct({
                                                            ...modalProduct,
                                                            metadata: {
                                                                ...modalProduct.metadata,
                                                                og: { ...modalProduct.metadata.og, description: e.target.value }
                                                            }
                                                        })
                                                    }
                                                />

                                                <label className="text-sm">OG: نوع</label>
                                                <Input
                                                    placeholder="مثلاً product, article, website"
                                                    value={modalProduct.metadata?.og?.type || ""}
                                                    onChange={(e) =>
                                                        setModalProduct({
                                                            ...modalProduct,
                                                            metadata: {
                                                                ...modalProduct.metadata,
                                                                og: { ...modalProduct.metadata.og, type: e.target.value }
                                                            }
                                                        })
                                                    }
                                                />

                                                <label className="text-sm">OG: لینک</label>
                                                <Input
                                                    placeholder="لینک محصول"
                                                    value={modalProduct.metadata?.og?.url || ""}
                                                    onChange={(e) =>
                                                        setModalProduct({
                                                            ...modalProduct,
                                                            metadata: {
                                                                ...modalProduct.metadata,
                                                                og: { ...modalProduct.metadata.og, url: e.target.value }
                                                            }
                                                        })
                                                    }
                                                />

                                                <label className="text-sm">OG: تصویر</label>
                                                {modalProduct.coverImage ? (
                                                    <img
                                                        src={
                                                            modalProduct.coverImage instanceof File
                                                                ? URL.createObjectURL(modalProduct.coverImage)
                                                                : modalProduct.coverImage || "/images/default-cover.jpg"
                                                        }
                                                        alt="Cover image"
                                                        className="aspect-square w-20 h-20 rounded-md object-cover group-hover:opacity-80 transition-opacity"
                                                    />
                                                ) : (
                                                    <img
                                                        src={'/images/assasins.jpg'}
                                                        alt={modalProduct.title}
                                                        className="aspect-square w-20 h-20 rounded-md object-cover group-hover:opacity-80 transition-opacity"
                                                    />
                                                )}
                                            </div>

                                            {/* Twitter */}
                                            <div className="space-y-3">
                                                <label className="text-sm">Twitter: عنوان</label>
                                                <Input
                                                    placeholder="عنوان توییتر"
                                                    value={modalProduct.metadata?.twitter?.title || ""}
                                                    onChange={(e) =>
                                                        setModalProduct({
                                                            ...modalProduct,
                                                            metadata: {
                                                                ...modalProduct.metadata,
                                                                twitter: { ...modalProduct.metadata.twitter, title: e.target.value }
                                                            }
                                                        })
                                                    }
                                                />

                                                <label className="text-sm">Twitter: توضیحات</label>
                                                <Textarea
                                                    placeholder="توضیحات کوتاه برای توییتر"
                                                    value={modalProduct.metadata?.twitter?.description || ""}
                                                    onChange={(e) =>
                                                        setModalProduct({
                                                            ...modalProduct,
                                                            metadata: {
                                                                ...modalProduct.metadata,
                                                                twitter: { ...modalProduct.metadata.twitter, description: e.target.value }
                                                            }
                                                        })
                                                    }
                                                />

                                                <label className="text-sm">Twitter: نوع کارت</label>
                                                <Input
                                                    placeholder="summary یا summary_large_image"
                                                    value={modalProduct.metadata?.twitter?.card || ""}
                                                    onChange={(e) =>
                                                        setModalProduct({
                                                            ...modalProduct,
                                                            metadata: {
                                                                ...modalProduct.metadata,
                                                                twitter: { ...modalProduct.metadata.twitter, card: e.target.value }
                                                            }
                                                        })
                                                    }
                                                />


                                                <label className="text-sm">Twitter: تصویر</label>
                                                {modalProduct.coverImage ? (
                                                    <img
                                                        src={
                                                            modalProduct.coverImage instanceof File
                                                                ? URL.createObjectURL(modalProduct.coverImage)
                                                                : modalProduct.coverImage || "/images/default-cover.jpg"
                                                        }
                                                        alt="Cover image"
                                                        className="aspect-square w-20 h-20 rounded-md object-cover group-hover:opacity-80 transition-opacity"
                                                    />
                                                ) : (
                                                    <img
                                                        src={'/images/assasins.jpg'}
                                                        alt={modalProduct.title}
                                                        className="aspect-square w-20 h-20 rounded-md object-cover group-hover:opacity-80 transition-opacity"
                                                    />
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </ScrollArea>

                            </TabsContent>

                        </Tabs>
                    )}


                </div>

                <div className="flex justify-between mt-6">
                    {currentStep > 1 ? (
                        <Button onClick={handlePrev} className="relative ps-12 overflow-hidden">
                            قبلی
                            <span className="bg-primary-foreground/15 pointer-events-none absolute inset-y-0 start-0 flex w-9 items-center justify-center">
                                <ChevronRightIcon className="opacity-60" size={16} aria-hidden="true" />
                            </span>
                        </Button>
                    ) : (
                        <div />
                    )}

                    <div className="flex gap-2">
                        {currentStep < steps.length && (
                            <Button onClick={handleNext} className="relative ps-12 overflow-hidden">
                                بعدی
                                <span className="bg-primary-foreground/15 pointer-events-none absolute inset-y-0 start-0 flex w-9 items-center justify-center">
                                    <ChevronLeftIcon className="opacity-60" size={16} aria-hidden="true" />
                                </span>
                            </Button>

                        )}

                        <Button
                            variant="secondary"
                            className="text-white"
                            onClick={() => {
                                setIsOpen(false)
                                setCurrentStep(1)
                            }}
                        >
                            بستن
                        </Button>

                        <Button disabled={isLoading} data-loading={isLoading || undefined} variant='secondary' className="text-white bg-[#24ff7f2d] hover:bg-[#24ff7f25]" onClick={handleSave}>
                            {isLoading && (
                                <div className="flex items-center justify-center">
                                    <LoaderCircleIcon className="animate-spin" size={16} aria-hidden="true" />
                                </div>
                            )}
                            ذخیره تغییرات
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog >
    );
};

export default EditProductModal;
